import { Box, Typography } from "@mui/material";
import toast, { Toaster } from "react-hot-toast";
import styles from "./Accounts.module.scss";
import { CommonButton } from "../../common/StyledComponents/StyledFields";
import ErrorPopup from "../../common/ErrorPopup";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import { useEffect, useState } from "react";
import Pagination from "../../common/pagination/pagination";
import editIcon from "../../../assets/EditIcon.svg";
import APILoading from "../../common/APILoading/APILoading";
import CreateorEditAccountDialog from "./CreateorEditAccountDialog";
import PageLoader from "../../common/PageLoader/PageLoader";

const Accounts = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [expenseAccounts, setExpenseAccounts] = useState<any[]>([]);
  const [createOrEditAccount, setCreateOrEditAccount] = useState(false);
  const [isAPILoading, setIsAPILoading] = useState(true);
  const [accountDetails, setAccountDetails] = useState<any>(null);
  const [isUpdateAccount, setIsUpdateAccount] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);

  const getExpenseAccounts = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.getAllExpenseAccounts,
      includeToken: true,
      params: {
        page: pageNumber - 1,
        size: 20,
        direction: "asc",
        sortBy: "accountId",
      },
    })
      .then((res) => {
        setIsAPILoading(false);
        setPageLoading(false);
        setExpenseAccounts(res?.data?.content);
        setTotalRecords(res?.data?.totalElements);
        const element = document.getElementById("expense_accounts");
        if (element) {
          element?.scrollIntoView({ behavior: "smooth", block: "start" });
          // Apply additional offset for a custom position
          window.scrollTo({
            top: 300,
            left: 0,
            behavior: "smooth",
          });
        }
      })
      .catch((err) => {
        setIsAPILoading(false);
        setPageLoading(false);
        toast.custom(
          <ErrorPopup showMessage={catchErrorMessageHandler(err)} />
        );
      });
  };

  useEffect(() => {
    setPageLoading(true);
    getExpenseAccounts();
  }, [pageNumber]);

  const handleCreateAccount = () => {
    setCreateOrEditAccount(true);
  };

  const handleClose = () => {
    setCreateOrEditAccount(false);
    setIsUpdateAccount(false);
    setAccountDetails(null);
  };

  const handleCloseGetAccounts = () => {
    handleClose();
    if (pageNumber === 1 || isUpdateAccount) {
      getExpenseAccounts();
    } else {
      setPageNumber(1);
    }
  };

  const handleEditAccount = (accountDetails: any) => {
    setAccountDetails(accountDetails);
    setCreateOrEditAccount(true);
    setIsUpdateAccount(true);
  };

  const renderHeaderSection = () => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: { xs: "flex-start", sm: "space-between" },
        }}
      >
        <Typography className="sub_heading">Accounts</Typography>
        <CommonButton onClick={handleCreateAccount}>
          Create New Account
        </CommonButton>
      </Box>
    );
  };

  const renderViewAccounts = () => {
    return (
      <Box sx={{ mt: "20px" }}>
        <Box sx={{ width: "100%", overflowX: "auto" }} id="expense_accounts">
          <table className={styles.table_container}>
            <thead>
              <th>Sr No</th>
              <th>Account ID</th>
              <th>Description</th>
              <th> Category</th>
              <th>Action</th>
            </thead>
            <tbody>
              {expenseAccounts?.map?.((row: any, index: number) => (
                <tr key={index}>
                  <td>{index + 1 + (pageNumber - 1) * 20}</td>
                  <td>{row?.accountId}</td>
                  <td>{row?.description}</td>
                  <td>{row?.categoryName}</td>
                  <td>
                    <Box sx={{ width: "35px", textAlign: "center" }}>
                      <Box
                        component={"img"}
                        src={editIcon}
                        alt="Edit"
                        onClick={() => {
                          handleEditAccount(row);
                        }}
                        sx={{ cursor: "pointer" }}
                      />
                    </Box>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
        {totalRecords > 0 && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: "15px" }}>
            <Pagination
              items={totalRecords}
              itemsPerPage={20}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
            />
          </Box>
        )}
      </Box>
    );
  };

  return (
    <Box className={styles.view_requests_main}>
      <Toaster />
      {renderHeaderSection()}
      {isAPILoading ? <APILoading /> : renderViewAccounts()}
      {createOrEditAccount && (
        <CreateorEditAccountDialog
          open={createOrEditAccount}
          handleClose={handleClose}
          handleCloseGetAccounts={handleCloseGetAccounts}
          isUpdateAccount={isUpdateAccount}
          accountDetails={accountDetails}
        />
      )}
      <PageLoader loading={!isAPILoading ? pageLoading : false} />
    </Box>
  );
};

export default Accounts;
